import { useState } from "react";
import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() =>
    typeof window === "object" ? window.matchMedia(query).matches : false,
  );

  useIsomorphicLayoutEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    mql.addListener(onChange);
    return () => {
      mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
};

export default useMediaQuery;
